export const normalizeHttpUrl = value => {
  const trimmedValue = value?.toString().trim();
  if (!trimmedValue) return '';

  if (/^https?:\/\//i.test(trimmedValue)) {
    return trimmedValue;
  }

  if (trimmedValue.startsWith('//')) {
    return `https:${trimmedValue}`;
  }

  return `https://${trimmedValue}`;
};

export const buildHttpUrl = value => {
  try {
    const url = new URL(normalizeHttpUrl(value));
    return ['http:', 'https:'].includes(url.protocol) ? url.toString() : null;
  } catch {
    return null;
  }
};
